(function () {
    'use strict';

    function eoAutoCompleteController($scope, $attrs, $element, $timeout) {
        var $ctrl = this;


        $ctrl.simulateQuery = false;
        $ctrl.isDisabled = false;

        // list of `state` value/display objects


        $ctrl.onSelectedItemChange = onSelectedItemChange;
        $ctrl.onSearchTextChange = searchTextChange;
        $ctrl.onSearchMethod = onSearchMethod;
        $ctrl.items = [];
        var isSerching = false;

        function onSearchMethod(query) {

            if (query && query.length > 0 && !isSerching) {

                return searchTextChange(query);


            }
        }

        $ctrl.newState = newState;

        function newState(state) {
            alert("Sorry! You'll need to create a Constitution for " + state + " first!");
        }

        // ******************************
        // Internal methods
        // ******************************

        /**
         * Search for states... use $timeout to simulate
         * remote dataservice call.
         */

        function searchTextChange(query) {

            if (query && query.length > 0 && !isSerching) {
                //console.log('start searching for'+query);
                isSerching = true;
                //  $ctrl.items=[];

                $ctrl.searchMethod(query).$promise.then(function (data) {

                    $ctrl.items = data;
                    console.log('search done by:' + query);
                    console.log(data);
                    isSerching = false;

                });
                ;


            }
        }

        function onSelectedItemChange(item) {
            if ($ctrl.selectedItemChange && item)
                $ctrl.selectedItemChange(item);
        }


    }

    var eoAutoComplete = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/autocomplete/eyeson.autocomplete.template.html',
        controller: eoAutoCompleteController,
        bindings: {

            placeholder: '@?',
            selectedItem: '=',
            searchMethod: '=',
            searchTextChange: '=?',
            selectedItemChange: '=?',
            isDisabled: '<?'
        }
    };
    angular
        .module('tikonApp')
        .component('eoAutocomplete', eoAutoComplete);
    eoAutoCompleteController.$inject = ['$scope', '$attrs', '$element', '$timeout'];
})();

